import { render, staticRenderFns } from "./RenewSubscriptionConfirmModal.vue?vue&type=template&id=890256d2&"
import script from "./RenewSubscriptionConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./RenewSubscriptionConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./RenewSubscriptionConfirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports